import PagePlaceholder from '@/components/PagePlaceholder';

export default function InsightsPage() {
  return (
    <PagePlaceholder
      title="Insights"
      subtitle="Thinking beyond generic AI. Articles and perspectives on custom intelligence, data strategy and enterprise technology."
    />
  );
}